import { createSlice } from '@reduxjs/toolkit';
import { GetStagedShipmentMetaState } from './types';
import { StoreStatus } from '../../core/types/common.types';
import { getStagedShipmentMetaThunk } from './thunks';

// Initial State
const initialState: GetStagedShipmentMetaState = {
  errors: null,
  status: StoreStatus.IDLE,
  response: null,
};

// Slice
export const getStagedShipmentMetaSlice = createSlice({
  name: 'getStagedShipmentMeta',
  initialState,
  reducers: {
    setValues: (state, action) => ({
      ...state,
      values: action.payload,
    }),
    resetStagedShipmentMeta: () => ({
      ...initialState,
    }),
  },
  extraReducers: (builder) => {
    builder.addCase(getStagedShipmentMetaThunk.pending.type, (state) => {
      state.status = StoreStatus.BUSY;
    });
    builder.addCase(getStagedShipmentMetaThunk.fulfilled.type, (state, action: any) => {
      state.status = StoreStatus.IDLE;
      state.response = action.payload;
      state.errors = null;
    });
    builder.addCase(getStagedShipmentMetaThunk.rejected.type, (state, action: any) => {
      state.status = StoreStatus.ERROR;
      state.errors = action.payload;
      state.response = null;
    });
  },
});

// Action creators
export const { resetStagedShipmentMeta, setValues } = getStagedShipmentMetaSlice.actions;
export * from './thunks';
export * from './selectors';
export default getStagedShipmentMetaSlice.reducer;
